import { Injectable } from "@nestjs/common";
import { CommonResponseModel } from "@needle-management/shared-models";
import { MachinesCreateDto, MachinesToggleDto } from "./dto";
import { MachinesRepo } from "./repository/machines-repo";


@Injectable()
export class MachinesService {
    constructor(
private readonly machinesRepo: MachinesRepo,
 ) {

    }

    async createMachineTypes(dto: MachinesCreateDto): Promise<CommonResponseModel> {
        const findRecord = await this.machinesRepo.findOne({ where: { machineType: dto.machineType, machine: dto.machine } });
        if (findRecord && (!dto.id || findRecord.id !== dto.id)) {
            return new CommonResponseModel(false, 25, "Machine Type already exists.");
        }
        if (dto.id) {
            await this.machinesRepo.update(dto.id, dto);
        } else {
            const machineType = this.machinesRepo.create(dto);
            await this.machinesRepo.save(machineType);
        }
        return new CommonResponseModel(
            true,
            dto?.id ? 922 : 923,
            dto.id ? 'Updated Successfully' : 'Created Successfully'
        );
    }


    async getAllMachineTypes(req: {}): Promise<CommonResponseModel> {

        const getMachineTypes = await this.machinesRepo.find({ order:{machineType:'ASC'}});
        if (!getMachineTypes.length) {
            return new CommonResponseModel(false, 35416, "No Data Found")
        } else {
            return new CommonResponseModel(true, 35416, 'machine type data retrieved successfully', getMachineTypes)
        }
    }

    
    async getActiveMachines(): Promise<CommonResponseModel> {
        const data = await this.machinesRepo.find({ where: { isActive: true }, order:{machineType:'ASC'} });
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        }
        return new CommonResponseModel(true, 1, 'No active Needle Size data found', []);
    }


    async toggleMachineTypes(req: MachinesToggleDto): Promise<CommonResponseModel> {
        const status = await this.machinesRepo.findOne({ where: { id: req.id } });
        if (status) {
            await this.machinesRepo.update({ id: req.id }, { isActive: !status.isActive })
            let message = status.isActive ? "  Deactivated Successfully" : " Activated Successfully"
            return await new CommonResponseModel(true, 65152, message)
        } else {
            return await new CommonResponseModel(false, 6541, "No Data Found")
        }
    }
}